import React from 'react';

const InfoDL = ({ title, children }) =>
{
    return (
        <dl className="info-item">
            <dt>{title}</dt>
            <dd>{children}</dd>
        </dl>
    );
};

export { InfoDL }; 